interface SkeletonProps {
  className?: string
  rounded?: 'md' | 'full'
}

export function Skeleton({ className = '', rounded = 'md' }: SkeletonProps) {
  const radius = rounded === 'full' ? 'rounded-full' : 'rounded-md'
  return (
    <span
      aria-hidden="true"
      className={`block animate-pulse bg-surface-subtle ${radius} ${className}`}
    />
  )
}

export function SkeletonText({
  lines = 1,
  className = '',
}: {
  lines?: number
  className?: string
}) {
  return (
    <span className={`block space-y-2 ${className}`}>
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton
          key={i}
          className={`h-3 ${i === lines - 1 && lines > 1 ? 'w-2/3' : 'w-full'}`}
        />
      ))}
    </span>
  )
}
